import React, { memo } from "react"
import { Box } from "@chakra-ui/react"

import { ProductMediaSwiperMobile } from "@app/components/Product/Media/ProductMediaSwiperMobile"
import { ProductMediaSwiperDesktop } from "@app/components/Product/Media/ProductMediaSwiperDesktop"

import { ProductCombinedProps } from "@root/types/global"

type Props = {
  product: ProductCombinedProps
}

export const ProductMedia: React.FC<Props> = memo(({ product }) => (
  <Box pos="relative">
    <Box display={["block", "none"]} position="relative">
      <ProductMediaSwiperMobile product={product} />
    </Box>
    <Box display={["none", "block"]}>
      <ProductMediaSwiperDesktop product={product} borderless={true} />
    </Box>
  </Box>
))
